'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var setFavicon = exports.setFavicon = function setFavicon(icon) {
  var link = document.createElement('link');
  link.type = 'image/x-icon';
  link.rel = 'shortcut icon';
  link.href = icon;
  document.getElementsByTagName('head')[0].appendChild(link);
};

var getWindowHeight = exports.getWindowHeight = function getWindowHeight() {
  return 'innerHeight' in window ? window.innerHeight : document.documentElement.offsetHeight;
};

var getWindowWidth = exports.getWindowWidth = function getWindowWidth() {
  return 'innerWidth' in window ? window.innerWidth : document.documentElement.offsetWidth;
};

var getBodyHeight = exports.getBodyHeight = function getBodyHeight() {
  var body = document.body;
  var html = document.documentElement;
  var height = void 0;
  if (typeof document.height !== 'undefined') {
    height = document.height;
  } else {
    height = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
  }
  return height;
};

var preventDefault = function preventDefault(e) {
  e = e || window.event;
  if (e.preventDefault) {
    e.preventDefault();
  }
  e.returnValue = false;
};

var preventDefaultForScrollKeys = function preventDefaultForScrollKeys(e) {
  var result = true;
  if (keys[e.keyCode]) {
    preventDefault(e);
    result = false;
  }
  return result;
};

var disableScroll = exports.disableScroll = function disableScroll() {
  if (window.addEventListener) {
    window.addEventListener('DOMMouseScroll', preventDefault, false); // older FF
  }
  window.onwheel = preventDefault; // modern standard
  window.onmousewheel = document.onmousewheel = preventDefault; // older browsers, IE
  window.ontouchmove = preventDefault; // mobile
  document.onkeydown = preventDefaultForScrollKeys;
};

var enableScroll = exports.enableScroll = function enableScroll() {
  if (window.removeEventListener) {
    window.removeEventListener('DOMMouseScroll', preventDefault, false);
  }
  window.onmousewheel = document.onmousewheel = null;
  window.onwheel = null;
  window.ontouchmove = null;
  document.onkeydown = null;
};

var isOpera = exports.isOpera = !!window.opr && !!opr.addons || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;
var isFirefox = exports.isFirefox = typeof InstallTrigger !== 'undefined';
var isSafari = exports.isSafari = Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0;
var isIE = /*@cc_on!@*/exports.isIE = false || !!document.documentMode;
var isEdge = exports.isEdge = !isIE && !!window.StyleMedia;
var isChrome = exports.isChrome = !!window.chrome && !!window.chrome.webstore;
var isBlink = exports.isBlink = (isChrome || isOpera) && !!window.CSS;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@its/util/lib/htmlUtil.js
 ** module id = 512
 ** module chunks = 0
 **/